import React, { Component } from 'react'
import { CardContainer } from './style';
import ExchangesCard from './ExchangesCard/ExchangesCard';
import RecurringExchangesCard from './RecurringExchangesCard/RecurringExchangesCard';
import AgreementsCard from './AgreementCard/agreementCard';

export default class RenderCard extends Component {
    renderElement = (props) => {
        switch (props.component) {
            case 'GrantCard':
                return <ExchangesCard {...props} />
            case 'RecurringCard':
                return <RecurringExchangesCard {...props} />
                case 'Agreements':
                    return <AgreementsCard {...props} />  
            default:
                break;
        }
    }
    render() {
        const { index } = this.props;
        return (
            <div>
                <CardContainer index={index % 2}>
                    {this.renderElement({...this.props})}
                </CardContainer>
            </div>
        )
    }
}
